module.exports = __webpack_public_path__ + "static/comfortershome-922a5330369b6d0015bf24abe1a9262b.jpeg";